import React from 'react';

export const PROGRESS_TYPE = {
  NONE: 'none',
  NORMAL: 'normal',
  INFINITY: 'infinity',
}

class Loading extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
    };

    this.renderLogo = this.renderLogo.bind(this)
    this.renderProgressInfinity = this.renderProgressInfinity.bind(this)
  }

  renderLogo() {
    return (<div className='logo-container'>
      <div className='logo'>
        <img className='logo-img' src="/img/logo96.png" alt="logo" />
      </div>
    </div>)
  }

  renderProgressInfinity() {
    return (
      <div class="progress progress-infinite">
        <div class="progress-bar3" >
        </div>
      </div>
    )
  }

  render() {
    const { loadingData } = this.props
    const isShowLogo = loadingData?.isShowLogo || false
    const progressType = loadingData?.progressType || PROGRESS_TYPE.NONE
    const progressValue = loadingData?.progressValue || 0
    const progressMax = loadingData?.progressMax || 0
    const title = loadingData?.title || null
    const desc = loadingData?.desc || null

    return (
      <div className={`modal-loading`}>
        <div className="modal-loading-content">
          {isShowLogo && this.renderLogo()}
          {progressType === PROGRESS_TYPE.NORMAL  && <progress className='progress-bar' value={progressValue} max={progressMax}>{`${progressValue}/${progressMax}`}</progress>}
          {progressType === PROGRESS_TYPE.INFINITY && this.renderProgressInfinity()}

          {title && <div className='title'>{title}</div>}
          {desc && <div className='desc'>{desc}</div>}
        </div>
      </div>
    );
  }
}

export default Loading